(() => {
  const SEARCH_WRAPPER_CLASS = 'wolfpack-brand-search';
  const HIDDEN_ITEM_CLASS = 'wolfpack-brand-search__item--hidden';

  function findBrandFacets(root = document) {
    return root.querySelectorAll(
      [
        '.facets--drawer .wolfpack-facet--brand',
        '.facets--drawer accordion-custom[data-filter-param-name*="brand"] .facets__panel',
        '.facets--drawer accordion-custom[data-filter-param-name*="vendor"] .facets__panel'
      ].join(',')
    );
  }

  function getItemLabel(item) {
    const label =
      item.querySelector('.checkbox__label-text') ||
      item.querySelector('label');

    return label?.textContent.trim().toLowerCase() || '';
  }

  function saveOriginalVisibility(item) {
    if (item.dataset.wolfpackVisibilitySaved === 'true') return;

    item.dataset.wolfpackVisibilitySaved = 'true';
    item.dataset.wolfpackWasHidden =
      item.classList.contains('hidden') ? 'true' : 'false';
    item.dataset.wolfpackWasMobileHidden =
      item.classList.contains('mobile:hidden') ? 'true' : 'false';
  }

  function exposeItemForSearch(item) {
    saveOriginalVisibility(item);
    item.classList.remove('hidden');
    item.classList.remove('mobile:hidden');
  }

  function restoreItemVisibility(item) {
    item.classList.remove(HIDDEN_ITEM_CLASS);

    if (item.dataset.wolfpackWasHidden === 'true') {
      item.classList.add('hidden');
    }

    if (item.dataset.wolfpackWasMobileHidden === 'true') {
      item.classList.add('mobile:hidden');
    }
  }

  function filterBrandItems(facet, query) {
    const normalizedQuery = query.trim().toLowerCase();
    const items = facet.querySelectorAll('.facets__inputs-list-item');
    const noResults = facet.querySelector(
      '.wolfpack-brand-search__no-results'
    );

    let matches = 0;

    items.forEach((item) => {
      if (!normalizedQuery) {
        restoreItemVisibility(item);
        return;
      }

      exposeItemForSearch(item);

      const isMatch = getItemLabel(item).includes(normalizedQuery);

      item.classList.toggle(HIDDEN_ITEM_CLASS, !isMatch);

      if (isMatch) matches += 1;
    });

    facet.classList.toggle(
      'wolfpack-brand-search--active',
      Boolean(normalizedQuery)
    );

    if (noResults) {
      noResults.hidden = !normalizedQuery || matches > 0;
    }
  }

  function createBrandSearch(facet) {
    if (facet.dataset.wolfpackBrandSearchReady === 'true') return;

    const list =
      facet.querySelector('.facets__inputs-wrapper') ||
      facet.querySelector('.facets__inputs-list');

    if (!list) return;

    facet.dataset.wolfpackBrandSearchReady = 'true';

    const wrapper = document.createElement('div');
    wrapper.className = SEARCH_WRAPPER_CLASS;

    wrapper.innerHTML = `
      <label class="wolfpack-brand-search__label">
        <span class="visually-hidden">Search brands</span>

        <span class="wolfpack-brand-search__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <circle cx="11" cy="11" r="6.5"></circle>
            <path d="M16 16L21 21"></path>
          </svg>
        </span>

        <input
          class="wolfpack-brand-search__input"
          type="search"
          placeholder="Search brands"
          autocomplete="off"
          spellcheck="false"
        >
      </label>

      <p class="wolfpack-brand-search__no-results" hidden>
        No matching brands
      </p>
    `;

    const inputsComponent =
  facet.querySelector('facet-inputs-component');

if (inputsComponent) {
  facet.insertBefore(wrapper, inputsComponent);
} else {
  facet.insertBefore(wrapper, facet.firstChild);
}

    const input = wrapper.querySelector(
      '.wolfpack-brand-search__input'
    );

    input.addEventListener('input', () => {
      filterBrandItems(facet, input.value);
    });

    input.addEventListener('search', () => {
      filterBrandItems(facet, input.value);
    });
  }

  function initializeBrandSearch(root = document) {
    findBrandFacets(root).forEach(createBrandSearch);
  }

document.addEventListener('DOMContentLoaded', () => {
  initializeBrandSearch();
  updateWolfpackFilterCount();

 const observer = new MutationObserver(() => {
  initializeBrandSearch();
  updateWolfpackFilterCount();
});

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
function updateWolfpackFilterCount(root = document) {
  root.querySelectorAll('.facets--drawer').forEach((drawer) => {
    const title =
      drawer.querySelector('.theme-drawer__title') ||
      drawer.querySelector('[class*="drawer__title"]');

    const countElement =
      drawer.querySelector('.filter-count-bubble__text') ||
      drawer.querySelector('.facets__active-count') ||
      drawer.querySelector('.facets__bubble');

    if (!title || !countElement) return;

    const countMatch = countElement.textContent.match(/\d+/);
    const count = countMatch ? Number(countMatch[0]) : 0;

    let label = title.querySelector('.wolfpack-drawer-filter-count');

    if (!label) {
      label = document.createElement('span');
      label.className = 'wolfpack-drawer-filter-count';
      title.appendChild(label);
    }

    const newText =
      `${count} ACTIVE ${count === 1 ? 'FILTER' : 'FILTERS'}`;

    if (label.textContent !== newText) {
      label.textContent = newText;
    }

    const originalBubble =
      countElement.closest('.filter-count-bubble') ||
      countElement.closest('.facets__bubble') ||
      countElement;

    originalBubble.style.setProperty('display', 'none', 'important');
  });
}
})();